export default __webpack_public_path__ + "static/media/dev.e6bed5eb.png";